// extracted by mini-css-extract-plugin
export default {"root":"_1O4uF","button":"_2_F7D","is-active":"_1Ppl-","isActive":"_1Ppl-"};